import React from "react";
import createReactClass from "create-react-class";

import MessageGroupsUsersSettingBox from "./message_groups_users_setting_box";
import MessageGroupsUsersAddUsersBox from "./message_groups_users_add_users_box";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      loading: true,
      data: {
        messages: [],
        messageGroupsUsers: [],
        messageGroupId: 0,
        currentUserId: 0,
        channelName: "",
        messageGroup: [],
        relatedUsers: [],
      },
    };
  },
  loadMessageGroupsUsersFromServer() {
    $.ajax({
      url: "/api/message/message_groups_users",
      dataType: "json",
      cache: false,
      data: {
        message_group_id: this.props.messageGroupId,
      },
      success: function(data) {
        this.setState({
          messageGroupsUsers: data.messageGroupsUsers,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  loadRelatedUsersFromServer() {
    $.ajax({
      url: "/api/user/related_users",
      dataType: "json",
      cache: false,
      data: {},
      success: function(data) {
        this.setState({
          relatedUsers: data.relatedUsers,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  handleChannelNameChange: function() {
    var channelName = this.channelName.value;
    var messageGroupId = this.props.messageGroupId;
    $.ajax({
      url: "/api/message/rename_message_group_channel_name",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: { message_group_id: messageGroupId, channel_name: channelName },
      cache: false,
      success: function(data) {
        if (data === "success") {
          this.setState({
            // data.messageGroup.channel_name: channelName
          });
        }
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  componentDidMount() {
    this.loadMessageGroupsUsersFromServer();
    this.loadRelatedUsersFromServer();
  },

  render() {
    var currentUserId = this.props.currentUserId;
    var messageGroupId = this.props.messageGroupId;
    // var channel_name = this.props.messageGroup.channel_name;
    var loadMessageListFromServer = this.loadMessageGroupsUsersFromServer;
    var loadRelatedUsersFromServer = this.loadRelatedUsersFromServer;
    var messageGroupsUserIds = [];
    var messageGroupsUsers = [];
    if (this.state.messageGroupsUsers !== undefined) {
      messageGroupsUserIds = this.state.messageGroupsUsers.map(function(
        group_user
      ) {
        return group_user.user_id;
      });
      messageGroupsUsers = this.state.messageGroupsUsers.map(function(
        group_user
      ) {
        return (
          <MessageGroupsUsersSettingBox
            messageGroupsUser={group_user}
            messageGroupId={messageGroupId}
            currentUserId={currentUserId}
            loadMessageListFromServer={loadMessageListFromServer}
            loadRelatedUsersFromServer={loadRelatedUsersFromServer}
            key={group_user.id}
          />
        );
      });
    }
    var relatedUsers = [];
    if (this.state.relatedUsers !== undefined) {
      relatedUsers = this.state.relatedUsers;
    }
    return (
      <div>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                aria-hidden="true"
                data-dismiss="modal"
                className="close"
                type="button"
              >
                ×
              </button>
              <h4 id="myModalLabel1" className="modal-title">
                メッセージルーム設定
              </h4>
            </div>
            <div className="modal-body">
              <form className="container" style={{ width: "100%" }}>
                <fieldset>
                  <div className="row">
                    <p>
                      このメッセージルームに名前を付けたり、メンバーを追加・削除することができます。
                    </p>
                    <section>
                      {/*			<label className="label">Room Name</label>
                            <label className="input">
          										<i className="icon-prepend">#</i>
          										<input type="text" name="channel_name" ref={(c) => {this.channelName = c;}} defaultValue={channel_name} onChange={this.handleChannelNameChange} placeholder="Room Name" />
          									</label>
                      */}
                    </section>
                    {messageGroupsUsers}

                    <MessageGroupsUsersAddUsersBox
                      relatedUsers={relatedUsers}
                      messageGroupId={messageGroupId}
                      messageGroupsUserIds={messageGroupsUserIds}
                      loadMessageListFromServer={
                        this.loadMessageGroupsUsersFromServer
                      }
                      loadRelatedUsersFromServer={
                        this.loadRelatedUsersFromServer
                      }
                      key="0"
                    />
                  </div>
                </fieldset>
              </form>
            </div>
            <div className="modal-footer">
              <button
                data-dismiss="modal"
                className="btn-u btn-u-default"
                type="button"
              >
                Close
              </button>&nbsp;
            </div>
          </div>
        </div>
      </div>
    );
  },
});
